import {Header, Page} from "../App";
import {useEffect, useState} from "react";

export function TeamPage(){
    return (
        <Page>
            <Chris/>
        </Page>
    )
}

function Chris(){
    const [floatImg, setFloatImg] = useState(window.innerWidth > 500)
    const breakHandler = () =>{
        if(window.innerWidth > 500){
            setFloatImg(true)
        } else{
            setFloatImg(false)
        }
    }
    useEffect(() => {
        window.addEventListener('resize', breakHandler)
        return () => window.removeEventListener('resize', breakHandler)
    }, []);
    return(
        <>
            <div>
                <div style={{
                    float: floatImg ? 'left' : 'none',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <div style={{marginRight: floatImg ? 30 : 0}}>
                        <img src="/images/chris.jpg"
                             align="top"
                             alt="its-a-me"
                             style={{
                                 width: '30vh',
                                 display: 'inline-block',
                                 marginTop: 10
                             }}
                        />
                        <p style={{textAlign: "center", fontSize: '0.95em'}}>
                            <strong>
                                Christopher R. Hartley<br/>
                                Software Architect, Inventor<br/>
                                President
                            </strong>
                        </p>
                    </div>
                </div>

                <div style={{textAlign: 'left'}}>
                    <p>
                        During my 9 years in the software industry, I have lead engineering teams in cross-functional
                        roles to deliver complex software solutions and cutting-edge new products for multi-million
                        dollar projects. I'm experienced as a Software Engineer, Software Architect, and Project Manager
                        with a wide variety of technologies and product types. I have helped lead teams and engineer
                        products for Cigna (Pharma Web Portal), IBM (Data Set Key Rotation, IBM Z Backup Resiliency,
                        Cloud Data Manager, Total Data Migration Facility), BMC Software (FDReport), and 21CS (STRATUS,
                        TRANSVERSE)
                    </p>
                    <p>
                        I'm the lead inventor of a cutting edge AI Model in the stages of being patented which will
                        revolutionize the technology for businesses and everyday users in terms of its power, accuracy,
                        and efficiency. My team of AI, machine learning, and software development experts able to
                        rapidly understand and tackle any problem you or your business might face.
                    </p>
                    <p>
                        As someone dedicated to creating high-quality products, I see how much bad software there is out
                        there, and want to help make sure your business software doesn't leave employees, users, and
                        customers cursing at their screens. I'll bring my passion for innovation, quality, and
                        performance to your team and help you deliver the best software and user experience possible.
                    </p>
                </div>

            </div>
        </>
    )

}